import { Session } from '../clientFlowtypes'

interface State {
  data: {[key: string]: Session};
}

const clientSessionsModule = {
  firestorePath: 'persons/{clientId}/sessions',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'clientSessions',
  statePropName: 'data',
  namespaced: true, // automatically added

  // this object is your store module (will be added as '/clients')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {
    all: (state: State) => state.data,
    // getById: state => id => state.data.find(user => user.id === id),
    getById: (state: State) => (id: string) => state.data[id],
    // getById: state => id => state.data[id],
  },
  mutations: {},
  actions: {
  },
}

export default clientSessionsModule
